import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { WorksheetActivityLog } from '../../api/models/activity-log';
import { ProjectService } from '../../api/services/project.services';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-order-activity-log',
  templateUrl: './order-activity-log.component.html',
  styleUrls: ['./order-activity-log.component.scss']
})
export class OrderActivityLogComponent implements OnInit {

  @ViewChild('accordion') accordion: NgbAccordion;

  activityLogs: WorksheetActivityLog[];
  infoMsg = ['There are no order activity logs to display.'];

  loading: boolean;
  errorMessage: string[] = [];

  worksheetId: string;
  disableExportButton: boolean = false;
  blob: any;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private projectService: ProjectService
    ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = true;
      this.worksheetId = params.id;
      this.projectService.getWorksheetActivityLog(params.id).subscribe(activityLogs => {
        this.activityLogs = activityLogs;
        this.loading = false;
      }, error => {
        this.loading = false;
        this.errorMessage.push(error.error.message);
      });
    });
  }

  preventToggle(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  doToggle(index: number) {
    if (this.accordion && this.accordion.activeIds) {
      const id = `ngb-panel-${index + 1}`;
      if(this.accordion.activeIds instanceof Array) {
        if (this.accordion.activeIds.includes(id)) {
          this.accordion.activeIds.splice(this.accordion.activeIds.indexOf(id));
        } else {
          this.accordion.activeIds.push(id);
        }
      } else {
        if (this.accordion.activeIds === id) {
          this.accordion.activeIds = null;
        } else {
          this.accordion.activeIds = id;
        }
      }
    }
  }

  isOpened(index: number) {
    const id = `ngb-panel-${index + 1}`;
    return this.accordion && this.accordion.activeIds && this.accordion.activeIds.includes(id);
  }

  goBack(): void {
    this.location.back();
  }

  downloadXls(){
    this.loading = true;
    this.disableExportButton = true;

    this.projectService.downloadWorksheetActivityLogs(this.worksheetId).subscribe((resp) => {
        const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'Worksheet Activity Logs ' + new Date();
        const data = resp.body;
        this.blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var downloadUrl = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName + '.xlsx';
        link.click();
        this.loading = false;
        this.disableExportButton = false;
    }, error => {
        this.errorMessage.push(error.error.message);
        this.loading = false;
        this.disableExportButton = false;
    });
   }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-activity-log/order-activity-log.component.ts